export default "__VITE_ASSET__DzdufnBq__"